import { updateTickerItems } from "@/mocks/home";

export default function UpdateTicker() {
  const loopItems = [...updateTickerItems, ...updateTickerItems];

  return (
    <div className="w-full bg-foreground-950 text-background-50">
      <div className="flex items-stretch h-9">
        <div className="flex items-center gap-2 px-3 md:px-6 shrink-0 bg-primary-500 text-background-50">
          <span className="w-1.5 h-1.5 rounded-full bg-background-50 animate-dot" />
          <span className="text-xs font-label tracking-wide whitespace-nowrap">
            更新条
          </span>
        </div>
        <div className="relative flex-1 overflow-hidden flex items-center">
          <div className="flex w-max animate-marquee">
            {loopItems.map((item, index) => (
              <span
                key={`ticker-${index}`}
                className="flex items-center text-xs text-background-200 whitespace-nowrap"
              >
                <i className="ri-arrow-right-s-line mx-3 text-primary-300" />
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}